import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// models
import { ApplicationSettings } from '../models/application-settings';
import { AuctionClusterRole } from '../models/auction-cluster-role';

// services
import { WebApiService } from './web-api.service';

@Injectable()
export class AuctionClusterRoleService {

  private apiPath: string;

  constructor(private appSettings: ApplicationSettings, private webApiService: WebApiService) {
    this.apiPath = this.appSettings.adminApi + 'auctionclusterrole';
  }

  getAuctionClusterRoles(): Observable<Array<AuctionClusterRole>> {
    return this.webApiService.getList(this.apiPath);
  }

  getAuctionClusterRole(auctionClusterRoleId: number): Observable<AuctionClusterRole> {
    return this.webApiService.get(this.apiPath, auctionClusterRoleId);
  }

  save(auctionClusterRole: AuctionClusterRole): Observable<any> {
    return this.webApiService.save<AuctionClusterRole>(this.apiPath, auctionClusterRole);
  }

  edit(auctionClusterRole: AuctionClusterRole): Observable<any> {
    return this.webApiService.edit<AuctionClusterRole>(this.apiPath, auctionClusterRole.auctionClusterRoleId, auctionClusterRole);
  }

  delete(auctionClusterRoleId: number): Observable<any> {
    return this.webApiService.delete(this.apiPath, auctionClusterRoleId);
  }
}
